import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

import { SessionService } from '../services/session.service';

import { MenumobileComponent } from './menumobile.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  @Input() public UserName: string;

  public logo: string;
  public site: string;

  private _opened: boolean = false;

  constructor(
    private sessionService: SessionService,
    private router: Router
  ) { }

  ngOnInit() {
    this.logo = environment.logo;
    this.site = environment.site;
  }

  public logout() {
    this.sessionService.logout();
    this.router.navigate(['public/login']);
  }

  public lanzar() {
    this._opened = !this._opened;
    MenumobileComponent.changeContrato.next(this._opened);
  }
}